import React from 'react'
import { DialogTitle, Typography, Box, Button, Dialog, DialogContent } from '@mui/material'
import OtpComponent from '../../../auth/components/OtpComponent'
import { useCancelDisbursementInstructionMutation } from '../../../../api/disbursements/disbursementApi'
import { setNotification } from '../../../shared/components/ui-widgets/uiWidgetsSlice'
import { RtkQueryHelper } from '../../../../api/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../../app/hooks'

interface CancelDisbursementInstructionComponentProps {
  assetHolderId: number
  instructionId: number
  onCloseDialog: () => void
}

const CancelDisbursementInstructionComponent: React.FC<CancelDisbursementInstructionComponentProps> = (props: CancelDisbursementInstructionComponentProps) => {
  const { assetHolderId, instructionId, onCloseDialog } = props

  const dispatch = useAppDispatch()

  const [apiCancelDisbursementInstruction, { isLoading }] = useCancelDisbursementInstructionMutation()

  const handleCancelDisbursementInstruction = (otp: string): void => {
    apiCancelDisbursementInstruction({
      assetHolderId, body: { instructionId, otp }
    })
      .unwrap()
      .then(() => {
        onCloseDialog()
      })
      .catch((err) => {
        dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
      })
  }

  return (
    <>
      <Dialog
        open={true}
        maxWidth={'sm'}
        fullWidth={true}
        disableEscapeKeyDown={true}
        onClose={() => { onCloseDialog() }}
        sx={{ p: 2 }}
      >
        <DialogTitle>Cancel Cash Out Instruction</DialogTitle>

        <DialogContent>
          <Typography variant={'body1'}>You are about to cancel your pending Cash Out Instruction. Are you sure you wish to continue? </Typography>
          <Box display={'flex'} justifyContent={'space-between'} sx={{ mt: 2 }}>
            <OtpComponent
              assetHolderId={assetHolderId}
              actionName={'Continue'}
              authenticatorConfigured={null}
              isLoading={isLoading}
              executeAction={(otp: string) => { handleCancelDisbursementInstruction(otp) }}
              disabled={false}
            />

            <Button
              variant={'outlined'}
              type="button"
              sx={{ ml: 2 }}
              onClick={() => { onCloseDialog() }}
            >
              Cancel
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default CancelDisbursementInstructionComponent
